import http from "@/api";

// Build the shareable link + caption for a product.
// The /api/share URL serves an OG-tagged page so WhatsApp/Twitter previews
// show the product image + price; humans get redirected to /p/{id}.
export function buildShareText(product, lang) {
  const ar = lang === "ar";
  const name = ar ? product.name_ar : product.name_en;
  const url = `${window.location.origin}/api/share/p/${product.id}`;
  const price = product.price_sar;
  const text = ar
    ? `🌸 لقيت هديتك في RARE GROUP — ${name}${price ? ` بسعر ${price} ر.ق` : ""}\n${url}`
    : `🌸 Found your gift at RARE GROUP — ${name}${price ? ` for ${price} QAR` : ""}\n${url}`;
  return { url, text, name };
}

export function whatsappShareUrl(product, lang) {
  const { text } = buildShareText(product, lang);
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

function trackShare(product) {
  http.post(`/products/${product.id}/share`, {
    name_ar: product.name_ar, name_en: product.name_en,
  }).catch(() => { /* non-blocking */ });
}

// Best-effort: fetch the product image as a File so mobile share sheets
// (Instagram/WhatsApp) can attach the photo. Returns null on CORS/other failure.
async function tryFetchImageFile(imageUrl, name) {
  try {
    const res = await fetch(imageUrl, { mode: "cors" });
    if (!res.ok) return null;
    const blob = await res.blob();
    if (!blob.type.startsWith("image/")) return null;
    const ext = (blob.type.split("/")[1] || "jpg").split("+")[0];
    return new File([blob], `rgpro-${(name || "gift").slice(0, 20)}.${ext}`, { type: blob.type });
  } catch {
    return null;
  }
}

// Returns "shared" (native sheet used or user cancelled) or "menu"
// (no Web Share API → caller should show the WhatsApp/copy fallback).
export async function shareProduct(product, lang) {
  const { url, text, name } = buildShareText(product, lang);
  trackShare(product);
  if (typeof navigator !== "undefined" && navigator.share) {
    const file = product.image ? await tryFetchImageFile(product.image, name) : null;
    try {
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ title: "RARE GROUP", text, files: [file] });
      } else {
        await navigator.share({ title: "RARE GROUP", text, url });
      }
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "shared"; // user closed the sheet
      return "menu";
    }
  }
  return "menu";
}
